export default __webpack_public_path__ + "static/media/arrowRight.7ac2bf95.svg";